import React from 'react';
import { AnimatedHamburgerButton } from '../basic';

import { MainAreaStyled, PanelStyled, SidePanelContainerStyled, TitleBarStyled } from './SidePanelContainer.styles';

export type PanelPos = 'left' | 'right';

export interface ISPCProps {
  panelPos: PanelPos;
  transitionDuration: number;
  panelOpen: boolean;
  panelWidth: number;

  onChange?: (panelOpen: boolean) => void;

  panel?: React.ReactNode;
  titleBar?: React.ReactNode;
  filter?: string;
}

export interface ISPCState {
}

export class SidePanelContainer extends React.Component<ISPCProps, ISPCState> {
  constructor(props: ISPCProps) {
    super(props);

    this.state = {
    };
  }

  public render() {
    return (
      <SidePanelContainerStyled pos={ this.props.panelPos } style={this.props.filter ? { filter: this.props.filter } : undefined }>
        <PanelStyled pos={this.props.panelPos} style={{
          transition: `width ${this.props.transitionDuration}s`,
          width: this.props.panelOpen ? this.props.panelWidth : 0
        }}>
          <div style={{width: this.props.panelWidth}}>
            { this.props.panel }
          </div>
        </PanelStyled>
        <MainAreaStyled>
          { this.props.children }
        </MainAreaStyled>
        <TitleBarStyled pos={ this.props.panelPos } style={{
          transition: `width ${this.props.transitionDuration}s`,
          width: `calc(100% - ${this.props.panelOpen ? this.props.panelWidth : 53}px)`
        }}>
          { this.props.titleBar }
        </TitleBarStyled>

        <AnimatedHamburgerButton
          isBurger={!this.props.panelOpen}
          transitionDuration={this.props.transitionDuration}
          onClick={this.props.onChange ? () => this.props.onChange!(!this.props.panelOpen) : undefined} />
      </SidePanelContainerStyled>
    );
  }
}
